import type { Lang } from '../../lib/i18n';
import { timerStrings } from '../../lib/tools';
import { EmbedLayout } from '../../components/tools/ToolParts';
import { HoldTimer, TIMER_SLUG } from '../../components/tools/HoldTimer';

export default function HoldTimerEmbed({ lang = 'en' as Lang }: { lang?: Lang }) {
  const t = timerStrings(lang);
  return (
    <EmbedLayout lang={lang} slug={TIMER_SLUG} title={t.embed.frameTitle} credit={t.embed.credit}>
      <HoldTimer lang={lang} embed />
    </EmbedLayout>
  );
}
